import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} PerformanceReportNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {PerformanceReportNotificationProps} props
 */
const PerformanceReportNotification = props => {
  const { notification } = props;

  const redirectUrl = pageUrlService.getDeltaPerformanceReportPageUrl(notification.OrgUnitId);

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label={
        'New performance data from ' + notification.CheckPoint.DataCollectionDate + ' is available.'
      }
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default PerformanceReportNotification;
